/**
 * Prüft, ob das Hinzufügen einer gerichteten Kante `from -> to` einen Zyklus
 * im bestehenden Graphen erzeugen würde.
 *
 * Eine neue Kante `from -> to` schließt einen Zyklus genau dann, wenn `from`
 * im bestehenden Graphen von `to` aus erreichbar ist. Es wird daher eine
 * Tiefensuche von `to` aus gestartet, die nach `from` sucht.
 */
export function wouldCreateCycle(
  edges: ReadonlyArray<{ source: string; target: string }>,
  from: string,
  to: string,
): boolean {
  if (from === to) return true;

  // Adjazenzliste aufbauen
  const adj = new Map<string, string[]>();
  for (const e of edges) {
    const list = adj.get(e.source);
    if (list) list.push(e.target);
    else adj.set(e.source, [e.target]);
  }

  const visited = new Set<string>();
  const stack: string[] = [to];

  while (stack.length > 0) {
    const node = stack.pop() as string;
    if (node === from) return true;
    if (visited.has(node)) continue;
    visited.add(node);
    const next = adj.get(node);
    if (next) {
      for (const n of next) {
        if (!visited.has(n)) stack.push(n);
      }
    }
  }

  return false;
}
